import { httpRequest } from '@/utils/umiRequest';
import { formatTableParams, formatTableResponse, isPro, isStaging } from '@/utils/utils';
import { getGlobalConfigByModule } from '../configs';

export interface saasDisputeRequest {
  currentPage: number;
  lists: Record<string, any>[];
  pageSize: number;
  total: number;
  totalPage: number;
}

export interface Datum {
  canned_response: CannedResponse[];
  created_at_gmt: string;
  freshdesk_id: number;
  id: number;
  name: string;
  personal: number;
  responses_count: number;
  type: number;
  updated_at_gmt: string;
  [property: string]: any;
}

export interface CannedResponse {
  amount: string;
  attachments: null;
  content_html: string;
  created_at_gmt: string;
  created_user_id: number;
  currency: string;
  folder_id: number;
  folder_type: number;
  freshdesk_id: number;
  group_ids: null;
  id: number;
  negative_title: string;
  positive_title: string;
  scope: number;
  title: string;
  type: string;
  updated_at_gmt: string;
  visibility: number;
  [property: string]: any;
}

/** 获取分组-new */
export async function getAllSessionsTable(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<saasDisputeRequest>('/saas-dispute', params, options);
}

//获取分组回复
export async function getFolderResponse(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.get<Datum[]>('/canned-response/folder-responses', params, options);
}

//获取分组回复
export async function getFolderResponseCancelable(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return httpRequest.cancelable.get('/canned-response/folder-responses', params, options);
}

//预设话术总数修改
export async function setUseTotal(params: Record<string, any>, options?: Record<string, any>) {
  return httpRequest.cancelable.post('/canned-response/use-total', params, options);
}

// 获取大数据订单详情
export function getOrderDetail(orderId: string, options?: Record<string, any>) {
  return httpRequest.get<any>(`/lfd/ppquery/order/${orderId}`, options);
}

// 获取大数据订单详情（可取消）
export function getOrderDetailCancelable(orderId: string, options?: Record<string, any>) {
  return httpRequest.cancelable.get<any>(`/lfd/ppquery/order/${orderId}`, options);
}

// 争议工单详情
export async function getSaasDisputeDetail(id: string, options?: Record<string, any>) {
  return await httpRequest.get<any>(`/saas-dispute/detail/${id}`, {}, options);
}

// 获取物流信息
export async function getTrackExpressRecord(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>('/lfd/track/express/record', params, options);
}

// 物流虚拟单号查询
export async function getVmExpressRecord(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.get<any>(`/lfd/track/vm-express/record`, params, options);
}

// 新增争议工单标签
export async function createSaasDisputeTag(
  id: string,
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`/saas-dispute/${id}/tags`, params, options);
}

// 设置争议工单标签
export async function setSaasDisputeTag(
  id: string,
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.put<any>(`/saas-dispute/${id}/tags`, params, options);
}

// 移除争议工单标签
export async function removeSaasDisputeTag(
  id: string,
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.delete<any>(`/saas-dispute/${id}/tags`, params, options);
}

// 获取标签
export async function getSaasDisputeTag(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.get<any>(`/tags`, params, options);
}

// 获取咨询原因
export async function getDisputeReason(options?: Record<string, any>) {
  return await httpRequest.get<any>(`/dispute-reason`, {}, options);
}

// 设置备注
export async function setRemarks(
  id: string,
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.put<any>(`/saas-dispute/${id}/remarks`, params, options);
}

// 修改订单号
export async function updateOrderNumber(
  id: string,
  params: { order_id: string },
  options?: Record<string, any>,
) {
  return await httpRequest.put<any>(`/saas-dispute/${id}/orders`, params, options);
}

// 设置备注
export async function messageRevoke(uuid: string, options?: Record<string, any>) {
  return await httpRequest.get<any>(`/saas-dispute/revoke/${uuid}`, {}, options);
}

// 获取智能推荐列表数据
export async function getIntelligentReplyListData(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`/chat/qdesksaas/recommendations`, params, {
    ...options,
    headers: {
      isRecommendations: true,
    },
  });
}

// 采纳计数
export async function updateAdoptionCount(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`/chat/qdesksaas/adoption`, params, options);
}

// 上传采纳信息
export async function updateAdoptionInfo(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`/chat/qdesksaas/adoption-record/store`, params, options);
}

// 新增推荐
export async function createRecommendations(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`/chat/qdesksaas/recommendations/store`, params, options);
}

// 变更采纳状态
export async function changeRecommendations(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.put<any>(
    `/saas-dispute/change-adoption/${params.id}`,
    { is_adoption: params.status },
    options,
  );
}

// 获取采纳状态
export async function getRecommendationStatus(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.get<any>(`/saas-dispute/adoption-status/${params.id}`, {}, options);
}

export async function toTranslate(message: any[], target_lang?: string, source?: number) {
  return await httpRequest.post<any>(
    `/util/translate`,
    {
      target_language: target_lang,
      text: message,
      source,
    },
    {},
  );
}

// 历史消息翻译结果保存
export async function saveSaasTranslateMessage(
  message_id: string,
  data: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`/saas-dispute/message/${message_id}`, data, options);
}

// 历史消息翻译结果保存
export async function saveEmailTranslateMessage(
  message_id: string,
  data: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`/email-ticket/email/${message_id}`, data, options);
}
// 批量关闭
export async function batchCloseDispute(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.put<any>(`/saas-dispute/set-status-close`, params, options);
}

// 工单标题翻译结果保存
export async function saveSubjectTranslateMessage(
  ticket_id: number,
  data: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`/email-ticket/translate/${ticket_id}`, data, options);
}

/**
 * 获取SaaS工单模块的配置
 * @param params
 * @param options
 * @param cancelable 可否取消
 * @returns
 */
export async function getSaasDisputeTicketConfig(
  options?: Record<string, any>,
  cancelable = false,
) {
  return await getGlobalConfigByModule('saas-ticket', options, cancelable);
}

// 获取订单追加单/原始单商品明细列表
export async function getUpsellItems(
  orderId: string,
) {
  return await httpRequest.get<any>(`/email-ticket/upsell-items/${orderId}`);
}
